import React, { useRef, useState, useEffect } from "react";
import Constants from "../constants/Constants";
import Loader from "./Loader";
import Sad from "../images/sad.svg";
const AddToLibrary = ({
  setCloseOffer,
  videoid,
  price,
  dispatch,
  setModel,
  manual,
  videoPause,
  setIsLibrary,
  biller,
}) => {
  const [buyingVideo, setBuyingVideo] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [confirmPurchase, setConfirmPurchase] = useState(false);
  const polling = useRef(null);
  useEffect(() => {
    if (manual) {
      videoPause();
      setConfirmPurchase(true);
    }
  }, [manual, videoPause]);
  const confirmToBuy = () => {
    videoPause();
    setConfirmPurchase(true);
  };
  const makePurchase = () => {
    let newWindow = null;
    if (biller !== 14) {
      newWindow = window.open(
        "https://addfriends.com/robots-working/",
        "_blank"
      );
    }
    setBuyingVideo(true);
    setConfirmPurchase(false);
    const formData = new FormData();
    formData.append("videoid", videoid);
    fetch(`${Constants.API}ils.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          if ("success" in res) {
            dispatch({
              type: "addLibrary",
              payload: videoid,
            });
            setBuyingVideo(false);
            setCloseOffer(true);
            setIsLibrary(true);
            setModel({});
          } else {
            const goTo = `https://wnu.com/secure/services/?api=camcharge&action=authandclose&auth_amount=${res.auth_amount}&member_id=${res.member_id}&returnurl=${res.returnurl}&include_css=${res.include_css}&description=${res.x_description}&pburl=${res.pburl}&x_description=${res.x_description}&x_pkey=${res.x_pkey}&x_vid=${videoid}&epoch_digest=${res.epoch_digest}`;
            newWindow.location = goTo; //This is just the URL sending user too
            startPolling(res.x_pkey, newWindow);
          }
        } else {
          newWindow.close();
          setHasError(true);
        }
      })
      .catch((error) => console.log(error));
  };
  const startPolling = (tok, newWindow) => {
    let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
    polling.current = evtSource;

    evtSource.onopen = function() {
      console.log("Checking with the 7 about the new site.");
    };

    evtSource.onmessage = function(e) {
      if (e.data === "SUCCESS!") {
        dispatch({
          type: "addLibrary",
          payload: videoid,
        });
        newWindow.close();
        evtSource.close();
        setBuyingVideo(false);
        setCloseOffer(true);
        setIsLibrary(true);
        setModel({});
      } else if (e.data === "STOP!") {
        newWindow.close();
        evtSource.close();
        setHasError(true);
      } else {
        console.log("...");
      }
    };

    evtSource.onerror = function() {
      evtSource.close();
      console.log("joined failed.");
      setHasError(true);
    };
  };
  if (confirmPurchase) {
    return (
      <div className="confirmPurchase videoPurchase">
        <div>
          <span>Make ${price / 100} Video Purchase?</span>
          <div className="confirmOptions">
            <div className="confirmBTN" onClick={makePurchase}>
              Yes
            </div>
            <div
              className="confirmBTN alt"
              onClick={() => setConfirmPurchase(false)}
            >
              No
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={buyingVideo ? "addToLibrary isBuying" : "addToLibrary"}>
      <span className="buyIt" onClick={confirmToBuy}>
        Add To My Library (<strong>${price / 100}</strong>)
      </span>{" "}
      <span
        className="closeLibraryPop"
        onClick={() => {
          setCloseOffer(true);
          setBuyingVideo(false);
          if (polling.current) {
            polling.current.close();
          }
        }}
      >
        &times;
      </span>
      {buyingVideo ? (
        <div className="makePurchase">
          {hasError ? (
            <div className="hasError">
              <div className="imgSad">
                <img src={Sad} alt="There was an error :(" />
              </div>
              <h2>
                An error has occured, please{" "}
                <a href="https://addfriends.com/contact-us">contact support</a>{" "}
                saying you cannot purchase videoID: {videoid}
              </h2>
            </div>
          ) : (
            <>
              <Loader />
              <h2>
                Please complete purchase on page that popped up, hit the x to
                cancel purchase.
              </h2>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default AddToLibrary;
